import { config } from '../utils/helpers/config.helpers'

export const getEnvironmentConfigs = () => ({
  cookieDomain: config.cookieDomain,
  publicApp: config.publicAppBaseUrl,
  homePage: config.commercialWebsiteUrl,
})
